import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerOrderDecision(orderId) {
  const response = await $.soap({
    body: {
      GetCustomerOrderDecision: {
        $xmlns: 'http://dla.mil/ems/db/order/customer_order',
        OrderID: orderId
      }
    },
    blueprint: {
      decision: {
        decisionStatus: '$..StatusID',
        explanation: '$..CRSDecisionExplanation',
        crsDecisionStatus: '$..CRSDecisionStatusID'
      }
    }
  });

  cleanUpResponse(response);
  return response.decision;
}
